import React, { Component } from 'react';
import Nointroduction from './nointroduction';

/**
 * 发货弹窗
 */
export class NoIntroduction extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { row, entity } = this.props;
        return (
            <div>
                <Nointroduction rows={row} entity={entity} />
            </div>
        );
    }
}
